<template>
  <div class="advertisement" :style="style">
    <div class="advertisement__timer">
      <timer>{{ timeLeft }}</timer>
    </div>
    <div class="advertisement__image">
      <img
        :src="graphic"
        alt="Advertisement"
        @load="startTimer"
        @error="stopTimer(true)"
      />
    </div>
  </div>
</template>

<script>
import Timer from "../components/Timer";

export default {
  name: "AdvertisementModule",

  components: { Timer },

  props: {
    duration: { type: Number },
    graphic: { type: String },
    windowInnerHeight: { type: String },
  },

  data() {
    return {
      timePassed: 0,
      timerInterval: null,
    };
  },

  computed: {
    timeLeft() {
      return (this.duration - this.timePassed).toFixed(1);
    },

    style() {
      return { minHeight: this.windowInnerHeight };
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue <= 0) {
        this.stopTimer(true);
      }
    },
  },

  beforeDestroy() {
    this.stopTimer();
  },

  methods: {
    startTimer() {
      this.timerInterval = setInterval(() => {
        this.timePassed += 0.1;
      }, 100);
    },

    stopTimer(forceExpire) {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);

        this.timerInterval = null;
      }

      if (forceExpire) {
        this.onExpire();
      }
    },

    onExpire() {
      this.$emit("expire");
    },
  },
};
</script>

<style lang="scss" scoped>
.advertisement {
  display: flex;
  flex-flow: row nowrap;
  padding: $size-space-1;
  justify-content: center;
  align-items: center;
}
.advertisement__timer {
  @include animate-float-fade-in;
  position: fixed;
  top: $size-space-1;
  right: $size-space-1;
}
.advertisement__image {
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
}
</style>
